export default {
  text: 'No internet connection. Please inform one of our staff member to check the connection 😊',
};
